"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseChannelId = exports.generateChannelId = void 0;
const types_1 = require("./types");
const generateChannelId = (params) => {
    switch (params.channel) {
        case types_1.WSChannel.candlesticks: {
            const { channel, market, resolution } = params;
            return [channel, market, resolution].join(":");
        }
        case types_1.WSChannel.books: {
            const { channel, market } = params;
            return [channel, market].join(":");
        }
        case types_1.WSChannel.recent_trades: {
            const { channel, market } = params;
            return [channel, market].join(":");
        }
        case types_1.WSChannel.orders: {
            const { channel, address } = params;
            return [channel, address].join(":");
        }
        case types_1.WSChannel.orders_by_market: {
            const { channel, market, address } = params;
            return [channel, market, address].join(":");
        }
        case types_1.WSChannel.balances: {
            const { channel, address } = params;
            return [channel, address].join(":");
        }
        case types_1.WSChannel.account_trades: {
            const { channel, address } = params;
            return [channel, address].join(":");
        }
        case types_1.WSChannel.account_trades_by_market: {
            const { channel, market, address } = params;
            return [channel, market, address].join(":");
        }
        case types_1.WSChannel.market_stats: {
            const { channel } = params;
            return [channel].join(":");
        }
        case types_1.WSChannel.market_stats_by_market: {
            const { channel, market } = params;
            return [channel, market].join(":");
        }
        case types_1.WSChannel.leverages: {
            const { channel, address } = params;
            return [channel, address].join(":");
        }
        case types_1.WSChannel.leverages_by_market: {
            const { channel, market, address } = params;
            return [channel, market, address].join(":");
        }
        case types_1.WSChannel.positions: {
            const { channel, address } = params;
            return [channel, address].join(":");
        }
        case types_1.WSChannel.positions_by_market: {
            const { channel, market, address } = params;
            return [channel, market, address].join(":");
        }
        case types_1.WSChannel.pools: {
            const { channel } = params;
            return [channel].join(":");
        }
        case types_1.WSChannel.pools_by_id: {
            const { channel, id } = params;
            return [channel, id].join(":");
        }
        case types_1.WSChannel.token_prices: {
            const { channel } = params;
            return [channel].join(":");
        }
        case types_1.WSChannel.token_prices_by_denom: {
            const { channel, denom } = params;
            return [channel, denom].join(":");
        }
        case types_1.WSChannel.commitments: {
            const { channel, address } = params;
            return [channel, address].join(":");
        }
        case types_1.WSChannel.cdp_borrows: {
            const { channel, address } = params;
            return [channel, address].join(":");
        }
        case types_1.WSChannel.cdp_collaterals: {
            const { channel, address } = params;
            return [channel, address].join(":");
        }
        case types_1.WSChannel.cdp_liquidate_collaterals: {
            const { channel } = params;
            return [channel].join(":");
        }
        case types_1.WSChannel.cdp_token_debts: {
            const { channel } = params;
            return [channel].join(":");
        }
        case types_1.WSChannel.cdp_token_debts_by_denom: {
            const { channel, denom } = params;
            return [channel, denom].join(":");
        }
        case types_1.WSChannel.cdp_reward_schemes: {
            const { channel } = params;
            return [channel].join(":");
        }
        case types_1.WSChannel.cdp_reward_debts: {
            const { channel, address } = params;
            return [channel, address].join(":");
        }
        case types_1.WSChannel.cdp_token_supply: {
            const { channel } = params;
            return [channel].join(":");
        }
        case types_1.WSChannel.cdp_token_supply_by_denom: {
            const { channel, denom } = params;
            return [channel, denom].join(":");
        }
        default:
            throw new Error(`invalid subscription channel: ${params.channel}`);
    }
};
exports.generateChannelId = generateChannelId;
const parseChannelId = (rawChannelId) => {
    const [channel, param0, param1] = rawChannelId.split(":");
    switch (channel) {
        case types_1.WSChannel.candlesticks:
            return {
                channel,
                market: param0,
                resolution: param1,
            };
        case types_1.WSChannel.books:
            return {
                channel,
                market: param0,
            };
        case types_1.WSChannel.recent_trades:
            return {
                channel,
                market: param0,
            };
        case types_1.WSChannel.orders:
            return {
                channel,
                address: param0,
            };
        case types_1.WSChannel.orders_by_market:
            return {
                channel,
                market: param0,
                address: param1,
            };
        case types_1.WSChannel.balances:
            return {
                channel,
                address: param0,
            };
        case types_1.WSChannel.account_trades:
            return {
                channel,
                address: param0,
            };
        case types_1.WSChannel.account_trades_by_market:
            return {
                channel,
                market: param0,
                address: param1,
            };
        case types_1.WSChannel.market_stats:
            return {
                channel,
            };
        case types_1.WSChannel.market_stats_by_market:
            return {
                channel,
                market: param0,
            };
        case types_1.WSChannel.leverages:
            return {
                channel,
                address: param0,
            };
        case types_1.WSChannel.leverages_by_market:
            return {
                channel,
                market: param0,
                address: param1,
            };
        case types_1.WSChannel.positions:
            return {
                channel,
                address: param0,
            };
        case types_1.WSChannel.positions_by_market:
            return {
                channel,
                market: param0,
                address: param1,
            };
        case types_1.WSChannel.pools:
            return {
                channel,
            };
        case types_1.WSChannel.pools_by_id:
            return {
                channel,
                id: param0,
            };
        case types_1.WSChannel.commitments:
            return {
                channel,
                address: param0,
            };
        case types_1.WSChannel.token_prices:
            return {
                channel,
            };
        case types_1.WSChannel.token_prices:
            return {
                channel,
                denom: param0,
            };
        case types_1.WSChannel.cdp_borrows:
            return {
                channel,
                address: param0,
            };
        case types_1.WSChannel.cdp_collaterals:
            return {
                channel,
                address: param0,
            };
        case types_1.WSChannel.cdp_liquidate_collaterals:
            return {
                channel,
            };
        case types_1.WSChannel.cdp_token_debts:
            return {
                channel,
            };
        case types_1.WSChannel.cdp_token_debts_by_denom:
            return {
                channel,
                denom: param0,
            };
        case types_1.WSChannel.cdp_reward_schemes:
            return {
                channel,
            };
        case types_1.WSChannel.cdp_reward_debts:
            return {
                channel,
                address: param0,
            };
        case types_1.WSChannel.cdp_token_supply:
            return {
                channel,
            };
        case types_1.WSChannel.cdp_token_supply_by_denom:
            return {
                channel,
                denom: param0,
            };
        default:
            throw new Error("Error parsing channelId");
    }
};
exports.parseChannelId = parseChannelId;
